(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-instagram-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-instagram-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const track = carousel.querySelector('.footer-instagram__track');
    const previous = carousel.querySelector('.footer-instagram__arrow--previous');
    const next = carousel.querySelector('.footer-instagram__arrow--next');
    const scrollAmount = () => Math.max(track.clientWidth * 0.8, 240);

    previous?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));

    if (carousel.dataset.source !== 'endpoint' || !carousel.dataset.endpoint) return;

    const makeCard = (item) => {
      const mediaType = String(item.media_type || item.type || '').toUpperCase();
      const filter = carousel.dataset.filter;
      const isReel = mediaType === 'VIDEO' || mediaType === 'REEL';
      if (filter === 'images' && isReel) return null;
      if (filter === 'reels' && !isReel) return null;

      const card = document.createElement('a');
      card.className = 'footer-instagram__card footer-instagram__card--' + carousel.dataset.aspectRatio;
      card.href = item.permalink || item.url || '#';
      card.target = '_blank';
      card.rel = 'noopener noreferrer';
      card.setAttribute('role', 'listitem');

      const image = document.createElement('img');
      image.className = 'footer-instagram__image';
      image.loading = 'lazy';
      image.src = item.thumbnail_url || item.media_url || item.image_url || '';
      image.alt = item.caption || 'Instagram post';
      card.appendChild(image);

      if (isReel) {
        const play = document.createElement('span');
        play.className = 'footer-instagram__play';
        play.setAttribute('aria-hidden', 'true');
        play.textContent = '▶';
        card.appendChild(play);
      }
      return card;
    };

    fetch(carousel.dataset.endpoint, { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((payload) => {
        const items = Array.isArray(payload) ? payload : (payload.data || []);
        const maxItems = Number(carousel.dataset.maxItems || 8);
        const cards = items.map(makeCard).filter(Boolean).slice(0, maxItems);
        if (cards.length) track.replaceChildren(...cards);
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
